import React, { useMemo } from 'react'
import { RoomSession } from '../../../../models/Room'
import { parseMetadata } from '../../../../common/util'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'

export interface NotStartedBadgeProps {
  roomSession: RoomSession
}

export const NotStartedBadge: React.FC<NotStartedBadgeProps> = ({ roomSession }) => {
  const { source = 'voice-memo', zocksAssistantStatus = 'notStarted' } = useMemo(() => (roomSession ? parseMetadata(roomSession.metadata) : {}), [roomSession])

  if (source !== 'voice-memo' || zocksAssistantStatus !== 'notStarted') {
    return null
  }
  return (
    <Tooltip
      className='paragraph-small'
      title='No meeting data available becuase the session was never started. You can safely delete this meeting.'
      placement='top'
      offset={[0, 10]}
    >
      <div className='d-flex align-items-center align-content-center zocks-border-primary-light zocks-bg-color-gray-200 p-1 zocks-border-0.25 gap-2'>
        <span className='button-small'>Not started</span>
      </div>
    </Tooltip>
  )
}
